module.exports = __webpack_public_path__ + "Roboto-Medium.fc78759e93a6cac50458.woff";


//////////////////
// WEBPACK FOOTER
// C:/ProactiView/ProactiView-Client/src/libs/mdbootstrap/font/roboto/Roboto-Medium.woff
// module id = ../../../../../src/libs/mdbootstrap/font/roboto/Roboto-Medium.woff
// module chunks = styles